import React, { FC, useEffect, useState } from "react";
import { DropdownOption } from "../../../models/dropdownOptionModel";
import { Element } from "../../../models/elementModel";
import "react-tippy/dist/tippy.css";
import { Tooltip } from "react-tippy";
import { useDispatch, useSelector } from "react-redux";
import ActionListComponent from "../../utilComponents/actionListComponent/actionListComponent";
import {
  startApplyRule,
  startResetDropDownRuleForOtherValues,
} from "../../../actions/ruleAction";
import { editElement } from "../../../actions/elementListAction";
import produce from "immer";
import { AppState } from "../../../reducers/rootReducer";
import "./Remarks.scss";
import { getSession } from "../../../selectors/appSelectors";
export interface RenderDropdownProps {
  index: string;
  element: Element;
  isPreview?: boolean;
}

const DropdownElement: FC<RenderDropdownProps> = ({
  index,
  element,
  isPreview = false,
}) => {
  const dispatch = useDispatch();
  const sessionState = useSelector(getSession);
  const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);
  const dropdownElementListI = useSelector(
    (state: AppState) => state.elementList.present
  );
  const [onChangeActions, setOnChangeActions] = useState(
    element.actions.filter((action) => {
      return action.actionType === "onChange";
    })
  );

  const [open, setIsOpen] = useState(false);

  useEffect(() => {
    setViewRemark(sessionState.viewRemark);
    console.log(sessionState.viewRemark);
  }, [sessionState]);

  // const inputClassName = `was-validated ${element.properties.required === true ? "input-group" : "form-group"
  //   }`;

  const inputClassName = `was-validated form-group`;

  let dropdownOption: DropdownOption[] = element.properties.options;

  async function OnChangeActions(value: string) {
    const selectedValueActions = onChangeActions.filter((act) => {
      return act.dropdownValue === value;
    });
    await Promise.all(
      selectedValueActions.map(async (action) => {
        dispatch(startApplyRule(action));
      })
    );

    const otherValueActions = onChangeActions.filter((act) => {
      return act.dropdownValue !== value;
    });
    await Promise.all(
      otherValueActions.map(async (action) => {
        dispatch(startResetDropDownRuleForOtherValues(action));
      })
    );
  }

  const optionsOfDrpdwn = dropdownOption.map((op) => {
    return (
      <option value={op.id} selected={op.selected} disabled={op.disabled}>
        {op.valueText}
      </option>
    );
  });

  const renderDropdownOptionsInPreview = () => {
    let options: DropdownOption[] = [
      {
        id: "",
        value: "",
        valueText: "--Select--",
        selected: true,
        disabled: true,
        filterValue: "",
      },
    ];
    if (element.properties.isDependant) {
      const parentValue = dropdownElementListI.filter(
        (dropdown) => dropdown.id === element.properties.parentDropdownId
      )[0].properties.selectedOption;
      options = options.concat(
        dropdownOption.filter((option) => option.filterValue === parentValue)
      );
    } else {
      options = options.concat(dropdownOption);
    }

    return options.map((op, i) => {
      return (
        <option key={i} value={`${op.id}`}>
          {op.valueText}
        </option>
      );
    });
  };

  const onChangeFunction = (value: any) => {
    const newElement = produce(element, (draft) => {
      draft.properties.selectedOption = value;
    });
    const childList = dropdownElementListI.filter(
      (dropdown) => dropdown.properties.parentDropdownId === element.id
    );
    dispatch(editElement(newElement));
    for (let i = 0; i < childList.length; i++) {
      let childElement = produce(childList[i], (draft) => {
        draft.properties.selectedOption = "";
      });
      dispatch(editElement(childElement));
    }
    OnChangeActions(value);
  };

  const defaultStyle = {
    marginTop: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginTop + "px",
    marginRight: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginRight + "px",
    marginBottom: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginBottom + "px",
    marginLeft: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginLeft + "px",
    textAlign: element.styles.textAlign,
  };

  //custome css - start
  const styleList = element.properties.cssStyles;

  const styleObj: { [key: string]: any } = {};

  for (let index = 0; index < styleList.length; index++) {
    styleObj[styleList[index].retrivedStyle] = styleList[index].value;
  }
  //custome css - end

  return (
    <div
      key={index}
      className={inputClassName}
      style={{
        ...defaultStyle,
      }}
    >
      <Tooltip title={element.properties.tooltip}>
        {!isPreview && (
          <select
            id={element.properties.id}
            className={element.properties.className}
            style={{
              height:
                element.styles.height === "" ||
                element.styles.height === undefined ||
                element.styles.height === "0"
                  ? "auto"
                  : element.styles.height + "px",
              width:
                element.styles.width === "" ||
                element.styles.width === undefined ||
                element.styles.width === "0"
                  ? ""
                  : element.styles.width + "px",
              fontSize:
                element.styles.fontSize === "" ||
                element.styles.fontSize === undefined ||
                element.styles.fontSize === "0"
                  ? ""
                  : element.styles.fontSize + "pt",
              color: element.styles.color,
              ...styleObj,
            }}
            required={element.properties.required}
            disabled={element.properties.disabled}
          >
            {optionsOfDrpdwn}
          </select>
        )}
        {isPreview && (
          <select
            id={element.properties.id}
            className={element.properties.className}
            style={{
              height:
                element.styles.height === "" ||
                element.styles.height === undefined ||
                element.styles.height === "0"
                  ? ""
                  : element.styles.height + "px",
              width:
                element.styles.width === "" ||
                element.styles.width === undefined ||
                element.styles.width === "0"
                  ? ""
                  : element.styles.width + "px",
              fontSize:
                element.styles.fontSize === "" ||
                element.styles.fontSize === undefined ||
                element.styles.fontSize === "0"
                  ? ""
                  : element.styles.fontSize + "pt",
              color: element.styles.color,
              ...styleObj,
            }}
            required={element.properties.required}
            disabled={element.properties.disabled}
            onChange={(e) => {
              onChangeFunction(e.target.value);
            }}
          >
            {element.properties.isDependant
              ? renderDropdownOptionsInPreview()
              : optionsOfDrpdwn}
          </select>
        )}
      </Tooltip>

      {isPreview &&
        viewRemark &&
        (element.properties.remark1 ||
          element.properties.remark2 ||
          element.properties.remark3 ||
          element.properties.remark4) && (
          <Tooltip
            interactive
            open={open}
            onRequestClose={() => setIsOpen(false)}
            html={
              <>
                <h6>Remarks of {element.name}</h6>
                {element.properties.remark1 !== undefined &&
                  element.properties.remark1 !== "" && (
                    <div className="remark">
                      Remark 1 : {element.properties.remark1}
                    </div>
                  )}
                {element.properties.remark2 !== undefined &&
                  element.properties.remark2 !== "" && (
                    <div className="remark">
                      Remark 2 : {element.properties.remark2}
                    </div>
                  )}
                {element.properties.remark3 !== undefined &&
                  element.properties.remark3 !== "" && (
                    <div className="remark">
                      Remark 3 : {element.properties.remark3}
                    </div>
                  )}
                {element.properties.remark4 !== undefined &&
                  element.properties.remark4 !== "" && (
                    <div className="remark">
                      Remark 4 : {element.properties.remark4}
                    </div>
                  )}
                {(element.properties.remark1 === undefined ||
                  element.properties.remark1 === "") &&
                  (element.properties.remark2 === undefined ||
                    element.properties.remark2 === "") &&
                  (element.properties.remark3 === undefined ||
                    element.properties.remark3 === "") &&
                  (element.properties.remark4 === undefined ||
                    element.properties.remark4 === "") && (
                    <div>No Remarks to Display</div>
                  )}
              </>
            }
            position="left"
          >
            <div style={{ textAlign: "end" }}>
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                onClick={() => {
                  setIsOpen(true);
                }}
              ></i>
            </div>
          </Tooltip>
        )}
      {/* {element.properties.required && (
        <div className="valid-feedback">
          {element.properties.valid_feedback}
        </div>
      )}
      {element.properties.required && (
        <div className="invalid-feedback">
          {element.properties.invalid_feedback}
        </div>
      )} */}
    </div>
  );
};

export default DropdownElement;
